import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './TemplateList.css';
import { Template } from '../types';
import { formatDate } from '../utils/dates';

const TemplateList: React.FC = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/templates');
      setTemplates(response.data);
    } catch (err: any) {
      console.error('Error fetching templates:', err);
      setError('Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTemplate = async (id: number) => {
    if (!window.confirm('Czy na pewno chcesz usunąć ten szablon?')) {
      return;
    }

    try {
      await axios.delete(`/api/templates/${id}`);
      setTemplates(templates.filter(t => t.id !== id));
    } catch (err: any) {
      console.error('Error deleting template:', err);
      setError('Failed to delete template');
    }
  };

  if (loading) {
    return <div className="loading">Ładowanie szablonów...</div>;
  }

  return (
    <div className="container">
      <div className="card template-list">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h1>Szablony Ofert</h1>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/templates/new')}
          >
            Nowy Szablon
          </button>
        </div>

        <div className="card-body">
          {error && <div className="alert alert-danger">{error}</div>}

          {templates.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">Nie masz jeszcze żadnych szablonów.</p>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/templates/new')}
              >
                Utwórz pierwszy szablon
              </button>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Nazwa</th>
                    <th>Opis</th>
                    <th>Ostatnia aktualizacja</th>
                    <th>Status</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  {templates.map(template => (
                    <tr key={template.id}>
                      <td>{template.name}</td>
                      <td>{template.description || '-'}</td>
                      <td>{formatDate(template.updated_at)}</td>
                      <td>
                        {template.is_default && (
                          <span className="badge bg-primary">Domyślny</span>
                        )}
                      </td>
                      <td>
                        <div className="btn-group">
                          <Link
                            to={`/templates/${template.id}`}
                            className="btn btn-outline-primary" // Corrected: "primary" instead of "primar"
                          >
                            Edytuj
                          </Link>

                          <button
                            className="btn btn-outline-danger"
                            onClick={() => handleDeleteTemplate(template.id)}
                            disabled={template.is_default}
                          >
                            Usuń
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TemplateList;